import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class LoanResortsService {
  authToken: any;
  user: any;
  baseURL: String;

  constructor(private http: HttpClient, private auth: AuthService) {
    this.baseURL = this.auth.baseURL;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  approvedLoanByWarehouseLocationByDateRange(params = {}) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.get(
      this.baseURL + 'reports/loan/loan-application-by-warehouse-location-avg',
      { 
        // headers: headers,
         params }
    );
  }

  approvedLoanByStateByDateRange(filter) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.post(
      this.baseURL + 'reports/loan/state/warehouses',
      filter,
      // { headers: headers }
    );
  }

  approvedLoanByCommodityWarehouseByDateRange(filter) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.post(
      this.baseURL + 'reports/loan/commodity/warehouses/',
      filter,
      // { headers: headers }
    );
  }

  approvedLoanByWhrByDateRange(filter) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.get(this.baseURL + `reports/loan/warehouses/${filter}`, {
      //headers: headers,
    });
  }

  approvedLoanByWarehouseByDateRange(params: {}) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.get(
      this.baseURL + 'reports/loan/loan-application-by-warehouse-avg',
      {  params }
    );
  }

  approvedLoanByCommodityByDateRange(params) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.get(
      this.baseURL + 'reports/loan/loan-application-by-commodity-avg',
      {  params }
    );
  }

  approvedLoanByUserTypeByDateRange(params = {}) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.get(
      this.baseURL + 'reports/loan/loan-application-by-usertype-avg',
      { 
        // headers: headers, 
        params }
    );
  }

  cpaTatReport(filter) {
    // this.loadToken();
    // let headers: HttpHeaders = new HttpHeaders();
    // headers = headers.append('Content-Type', 'application/json');
    // headers = headers.append('Authorization', this.authToken);
    return this.http.post(this.baseURL + 'reports/npa/tat', filter, {
      // headers: headers,
    });
  }

  // Approved loan application under state
  getApprovedLoanUnderState(state = 'N.A.', obj = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(
      this.baseURL +
        `reports/loan/application/loan-application/approved/state/${state}`,
      { params: obj, }
    );
  }

  // Approved loan application under commodity
  getApprovedLoanUnderCommodity(commodity, obj = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(
      this.baseURL +
        `reports/loan/application/loan-application/approved/commodity/${commodity}`,
      { params: obj, 
        // headers: headers 
      }
    );
  }

  // Approved loan application under warehouse
  getApprovedLoanUnderWarehouse(warehouse, obj = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.get(
      this.baseURL +
        `reports/loan/application/loan-application/approved/warehouses/${warehouse}`,
      { params: obj, 
        // headers: headers 
      }
    );
  }
}
